// IgChat state
const CHAT_STATE = {
  MINIMIZED: 0,
  CONVERSATIONS_LIST: 1,
  CONVERSATION: 2,
  LOADING: 3,
  NEW_CONVERSATION_FORM: 4,
  NEW_GROUP_FORM: 5,
};

const NEW_CONVERSATION_FORM_STATE = {
  PARTICIPANT_SELECTION: 0,
  BODY_DEFINITION: 1,
};

const NEW_GROUP_FORM_STATE = {
  PARTICIPANTS_SELECTION: 0,
  SUBJECT_DEFINITION: 1,
};

const CHAT_DEFAULT_SUBJECT = 'IG::IG_CHAT_NO_SUBJECT';
const CHAT_DEFAULT_BODY = 'IG::IG_CHAT_NO_BODY';

const CONVERSATION_TYPES = {
  GROUP: 'group',
  PAIR: 'pair',
};

export {
  CHAT_STATE,
  CHAT_DEFAULT_SUBJECT,
  CHAT_DEFAULT_BODY,
  NEW_GROUP_FORM_STATE,
  NEW_CONVERSATION_FORM_STATE,
  CONVERSATION_TYPES,
};
